//tdm = tag der Admin
import api from './services/mkm.api.js'

const resource = '/tdaworkshops'

export default {
    alle() {
        return api.get(`${resource}`)
    },
}